import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from 'app/app.config';
import { sanitizeVehiclePassportFragment } from './app/vehicle-passport/vehicle-passport-fragment';

sanitizeVehiclePassportFragment();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
